export default __webpack_public_path__ + "static/media/013.950836dd.jpg";